import { dailyMetricsService } from './dailyMetricsService';

export default dailyMetricsService;
